import { render, staticRenderFns } from "./ClientGoodsList.vue?vue&type=template&id=51768f18&scoped=true&"
import script from "./ClientGoodsList.vue?vue&type=script&lang=ts&"
export * from "./ClientGoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./ClientGoodsList.vue?vue&type=style&index=0&id=51768f18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51768f18",
  null
  
)

export default component.exports